import sbfolded from "../../assets/skate_folded.webp";
import { FaTshirt } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./productheader.css";

const ProductHeader = ({ title = "Brewed for Your Wardrobe" }) => {
  return (
    <section className="product-header">
      <div className="content-padding">
        <div className="product-header-layout">
          <div className="product-header-copy">
            <p className="product-header-eyebrow">Solo Pints Clothing</p>

            <h1>{title}</h1>

            <p className="product-header-text">
              Beer-inspired apparel and lifestyle pieces made for pub gardens,
              last trains and easy weekends.
            </p>

            <Link to="/shop" className="product-header-btn">
              <FaTshirt />
              <span>Shop the Drop</span>
            </Link>
          </div>

          <div className="product-header-media">
            <img
              src={sbfolded}
              alt="Folded Solo Pints graphic T-shirt"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductHeader;
